import { useThree as D } from "@react-three/fiber";
import { memo as F, useMemo as b, useEffect as T } from "react";
import { RgView as y } from "../../3d/rg-render-types/index4.js";
import { mergeMeshes as E } from "../../geometry-utils/three/index17.js";
import { useFunction as _ } from "../../hooks/index2.js";
import { getRgParentOfType as $ } from "../../utils/rg-util/index4.js";
import { ChildrenToMerge as j } from "./index4.js";
import { jsx as C, Fragment as N } from "react/jsx-runtime";
const P = F(({
  objs: r,
  parent: O,
  layer: o,
  visibility: s,
  colourFunc: m,
  onClick: d,
  onContextMenu: a,
  onDoubleClick: c,
  onPointerUp: v,
  onPointerDown: p,
  onPointerOver: f,
  onPointerOut: g,
  onPointerEnter: u,
  onPointerLeave: l,
  onPointerMove: h,
  onPointerCancel: M
}) => {
  const t = b(() => {
    const e = new y({
      ...O,
      children: r
    });
    return e.removeMesh(), e;
  }, [r]), n = b(() => {
    for (const e of t.rgChildren)
      o.cancel && o.cancel(e.userData) ? e.setVisibility({
        visibility: []
      }) : e.setVisibility({
        visibility: s,
        visible: o.visible
      });
    return t.updateWorldMatrix(!1, !0), t.updateColour(m), E(t);
  }, [t, s, o, m]), R = D().raycaster, i = _((e, V) => {
    e.timeStamp = Date.now(), t.setVisibility({
      visibility: s,
      visible: o.visible
    });
    const w = R.intersectObject(t), x = $(w[0].object.view.userData, j);
    V({
      event: e,
      obj: x,
      intersections: w
    });
  });
  return T(() => () => n.dispose(), [n]), t.activeMeshes ? /* @__PURE__ */ C("mesh", {
    name: `merged-${r[0].type}-${r.length}`,
    position: t.position,
    rotation: t.rotation,
    geometry: n,
    material: o.material,
    renderOrder: o.renderOrder,
    onClick: d ? (e) => i(e, d) : void 0,
    onContextMenu: a ? (e) => i(e, a) : void 0,
    onDoubleClick: c ? (e) => i(e, c) : void 0,
    onPointerUp: v ? (e) => i(e, v) : void 0,
    onPointerDown: p ? (e) => i(e, p) : void 0,
    onPointerOver: f ? (e) => i(e, f) : void 0,
    onPointerOut: g ? (e) => i(e, g) : void 0,
    onPointerEnter: u ? (e) => i(e, u) : void 0,
    onPointerLeave: l ? (e) => i(e, l) : void 0,
    onPointerMove: h ? (e) => i(e, h) : void 0,
    onPointerCancel: M ? (e) => i(e, M) : void 0
  }) : /* @__PURE__ */ C(N, {});
});
P.displayName = "RgMergeFC";
export {
  P as RgMergeFC
};
//# sourceMappingURL=index5.js.map
